module.exports = __webpack_public_path__ + "img/client2.9518a508.svg";